export default __webpack_public_path__ + "static/media/already_working_with_therapist.121a8d4e.svg";